export const BUSINESS_DAYS = [
  { key: 'mon', label: 'Monday' },
  { key: 'tue', label: 'Tuesday' },
  { key: 'wed', label: 'Wednesday' },
  { key: 'thu', label: 'Thursday' },
  { key: 'fri', label: 'Friday' },
  { key: 'sat', label: 'Saturday' },
  { key: 'sun', label: 'Sunday' },
]

/** @returns {Record<string, { open: string, close: string }>} */
export function defaultBusinessHours() {
  return {
    mon: { open: '10:00', close: '22:00' },
    tue: { open: '10:00', close: '22:00' },
    wed: { open: '10:00', close: '22:00' },
    thu: { open: '10:00', close: '22:00' },
    fri: { open: '10:00', close: '22:00' },
    sat: { open: '10:00', close: '22:00' },
    sun: { open: '12:00', close: '20:00' },
  }
}

/**
 * @param {Record<string, { open?: string, close?: string }> | null | undefined} hours
 * @returns {Record<string, { open: string, close: string }>}
 */
export function normalizeBusinessHours(hours) {
  const defaults = defaultBusinessHours()
  const normalized = { ...defaults }

  if (!hours) {
    return normalized
  }

  for (const day of BUSINESS_DAYS) {
    normalized[day.key] = {
      open: hours[day.key]?.open ?? defaults[day.key].open,
      close: hours[day.key]?.close ?? defaults[day.key].close,
    }
  }

  return normalized
}
